import { render, staticRenderFns } from "./Taxpayer.vue?vue&type=template&id=608bdc1c&"
import script from "./Taxpayer.vue?vue&type=script&lang=js&"
export * from "./Taxpayer.vue?vue&type=script&lang=js&"
import style0 from "./Taxpayer.vue?vue&type=style&index=0&id=608bdc1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports